import React, { useCallback } from 'react';
import styles from './styles.module.sass';
import { ECGCaptureItem, ScreenTitle } from 'components';
import { useAppDispatch, useAppSelector, useEffect } from 'hooks';
import { ECGActions } from 'utils/store';
import { DataStatus, UserRole } from 'types/enums';
import { getLocaleDate } from 'utils';
import { PartnerECGView } from './partner-ecg-view';

export const ECGCapture = () => {
  const dispatch = useAppDispatch();
  const { ecgCapture, status } = useAppSelector(({ ecg }) => ecg);
  const userData = useAppSelector(({ user }) => user.data);
  const patientId = userData?.patientId;
  const isLoading = status === DataStatus.LOADING;

  useEffect(() => {
    if (!patientId) {
      return;
    }
    dispatch(ECGActions.getECGCapture(patientId));
  }, [dispatch, patientId]);

  const generateContent = useCallback(() => {
    if (!patientId) {
      return <h2 className={styles.title}>No patient id</h2>;
    }
    if (isLoading) {
      return <h2 className={styles.title}>Loading...</h2>;
    }

    if (!ecgCapture.length) {
      return <h2 className={styles.title}>No ecg data find</h2>;
    }

    return (
      <>
        <ScreenTitle title='Your ECG captures:' />
        {ecgCapture.map((waveform) => (
          <div className={styles.item} key={waveform.id}>
            <h2>{getLocaleDate(waveform.submittedTimestamp, 'dddd, D MMMM YYYY')}</h2>
            <ECGCaptureItem {...waveform} />
          </div>
        ))}
      </>
    );
  }, [ecgCapture, isLoading, patientId]);

  // Show partner-specific ECG view for partner users
  if (userData?.role === UserRole.PARTNER) {
    return <PartnerECGView />;
  }

  return generateContent();
};
